module.exports = __webpack_public_path__ + "font/open-sans-regular.f57a62e.woff2";